import { BrowserRouter, useRoutes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import routes from "@/router";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter
        // NOTE: basename is commented out for standalone development
        // When you need to rebuild for the portfolio, uncomment this line:
        basename="/projects/alex-chen-photography"
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
